

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DraggableIcon from './DraggableIcon.vue';
import { isLink } from '@/jbi-shared/util/validate-email-domains.util';
import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import AttributeActionButtons from './AttributeActionButtons.vue';

@Component({
  components: {
    DraggableIcon,
    AttributeActionButtons
  }
})
export default class GroupLevelAttributeLinkField extends Vue {
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop() fieldClasses!: any;
  @Prop() duplicationError!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) overrideDisableDraggable!: boolean;
  @Prop({ default: false }) overrideDisableAttributeButton!: boolean;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;

  fieldErrorMsg: string = '';
  isLinkFormatCorrect: boolean = true;

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  @Watch('isRequired', { immediate: true })
  updateErrorState() {
    if (this.attributeValue.value) {
      this.validateLinkFormat();
      return;
    }

    this.attributeValue.hasFieldError = this.isRequired;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('attributeValue.value')
  validateLinkFormat(): void {
    if (this.isRequired && !this.attributeValue.value) {
      this.fieldErrorMsg = `${this.attributeValue.label} is required.`;
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    }

    // Run validator when there's value
    if (this.attributeValue.value) {
      this.isLinkFormatCorrect = isLink(this.attributeValue.value as string);
    }

    if (!this.isLinkFormatCorrect) {
      this.fieldErrorMsg = 'Invalid link format.';
      this.attributeValue.hasFieldError = true;
    } else {
      this.fieldErrorMsg = '';
      this.attributeValue.hasFieldError = false;
    }

    this.updateAttributeValue(this.attributeValue);
  }
}
